import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whyus-safetymeasures',
  templateUrl: './whyus-safetymeasures.component.html',
  styleUrls: ['./whyus-safetymeasures.component.less']
})
export class WhyusSafetymeasuresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
